import { PageSize } from '@/constant';
import { GetWorkerLodgingListParams } from '@/services';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IMSelectLodgingPopupDetailStore,
	IPayloadGetMSelectLodgingPopupListRequest,
	IPayloadGetMSelectLodgingPopupListSuccess,
} from './m-select-lodging-popup.type';

const InitParams: GetWorkerLodgingListParams = {
	page: 1,
	pageSize: PageSize.S,
	searchTypes: [],
};

const initialState = {
	fetching: false,
	mSelectLodgingPopupList: [] as IMSelectLodgingPopupDetailStore[],
	params: InitParams,
	total: 0,
};

const mSelectLodgingPopupSlice = createSlice({
	initialState,
	name: 'mSelectLodgingPopup',
	reducers: {
		/**---- GET M_SELECT_LODGING_POPUP LIST START ---- */
		getMSelectLodgingPopupListRequest: (
			state,
			action: PayloadAction<IPayloadGetMSelectLodgingPopupListRequest>
		) => {
			state.fetching = true;
			state.params = action?.payload;
		},
		getMSelectLodgingPopupListSuccess: (
			state,
			action: PayloadAction<IPayloadGetMSelectLodgingPopupListSuccess>
		) => {
			const { mSelectLodgingPopupList, total } = action.payload;
			state.fetching = false;
			state.mSelectLodgingPopupList = mSelectLodgingPopupList;
			state.total = total;
		},
		getMSelectLodgingPopupListFailure: (state) => {
			state.fetching = false;
			state.mSelectLodgingPopupList = [];
			state.total = 0;
		},
		/**---- GET M_SELECT_LODGING_POPUP LIST END ---- */
	},
});

export const MSelectLodgingPopupSelectors = {
	selectFetching: (state: RootState) => state.mSelectLodgingPopup.fetching,
	selectTotal: (state: RootState) => state.mSelectLodgingPopup.total,
	selectMSelectLodgingPopupList: (state: RootState) =>
		state.mSelectLodgingPopup.mSelectLodgingPopupList,
	selectParams: (state: RootState) => state.mSelectLodgingPopup.params,
};

export const MSelectLodgingPopupActions = mSelectLodgingPopupSlice.actions;
export const MSelectLodgingPopupReducer = mSelectLodgingPopupSlice.reducer;
